export const BOTTOM_SHEET_ANIMATION_DURATION_SHORT = 320;
export const BOTTOM_SHEET_ANIMATION_DURATION_LONG = 480;
export const BOTTOM_SHEET_ANIMATION_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
export const BOTTOM_SHEET_HEIGHT_THRESHOLD_VH = 0.5;
